import React from "react";
import Button from "../components/button/Button";

interface ISuretyModel {
  type?: "unpaid" | "no-subscription";
  toggleModel: () => void;
}

const SubscriptionInfoModel = ({ type, toggleModel }: ISuretyModel) => {
  return (
    <div className="w-full h-full fixed top-0 bg-black/50 backdrop-blur-sm left-0 z-50 flex items-center justify-center px-4">
      <div className="p-7 rounded-2xl bg-white shadow-pop w-full max-w-[480px] fade-up">
        <div className="flex items-start gap-4">
          <div className="h-11 w-11 rounded-full bg-blue/10 flex items-center justify-center shrink-0">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5299D3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </div>
          <div>
            <h2 className="font-display text-lg font-semibold tracking-tight text-lightBlack capitalize">
              {type === "no-subscription" ? "Subscription required" : `Subscription ${type}`}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              {type === "no-subscription"
                ? "Please buy a subscription to continue using Coach AI."
                : `Please update your subscription — it's ${type}.`}
            </p>
          </div>
        </div>

        <div className="mt-7 flex items-center justify-end">
          <div className="w-auto">
            <Button className="!w-auto !px-6" onClick={toggleModel}>
              Got it
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionInfoModel;
